module.exports = __webpack_public_path__ + "static/media/pickup_qty.de563a06.svg";